"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpPage = SignUpPage;
var jsx_runtime_1 = require("react/jsx-runtime");
function SignUpPage() {
    return (0, jsx_runtime_1.jsx)("div", { children: "Sign Up Page" });
}
